var Cookies = require('js-cookie');
var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEConstants = require('../../../base/hpe.constants');

var template = require('../templates/hpe.productlist.utilitybar.template.tpl');
var HitSelectCollectionView = require('./hpe.productlist.utilitybar.hitselect.view');

/**
 * Product List Utility Bar view
 */
module.exports = AmpersandView.extend({

    template: template,

    /**
     * bindings
     */
    bindings: {
        'model.specsUIVisible': {
            type: 'booleanClass',
            selector: '.product-list-utility-bar-showspecs',
            name: 'hide',
            invert: true
        },
        'model.paginationUIVisible': {
            type: 'booleanClass',
            selector: '.product-list-utility-bar-pagination',
            name: 'hide',
            invert: true
        },
        'model.specsVisible': {
            type: 'booleanAttribute',
            hook: 'showspecs',
            name: 'checked'
        },
        'model.specsAnalytics': {
            type: 'attribute',
            hook: 'showspecs',
            name: 'data-analytics-name'
        },
        // 'model.totalMatches': {
        //     type: 'text',
        //     hook: 'total'
        // },
        // 'model.startOffset': {
        //     type: 'text',
        //     hook: 'startOffset'
        // },
        // 'model.endOffset': {
        //     type: 'text',
        //     hook: 'endOffset'
        // },
        'model.labelResults': {
            type: 'text',
            hook: 'results-label'
        },
        'model.labelShowSpecs': {
            type: 'text',
            hook: 'showspecs-label'
        },
        'model.labelView': {
            type: 'text',
            hook: 'hits-label'
        }
        // '.model.labelDivisor': {
        //     type: 'text',
        //     hook: 'divisor'
        // },
        // 'model.isSingleResult': {
        //     type: 'booleanClass',
        //     selector: '.product-list-utility-bar-header',
        //     name: 'singlularResult'
        // }
    },

    /**
     * events
     */
    events: {
        'change input': 'onSpecsToggle'
    },

    subviews: {
        hitSelector: {
            selector: '.product-list-utility-bar-hitselect',
            waitFor: 'model.hitsSelect',
            prepareView: function(el) {
                return new HitSelectCollectionView({
                    el: el,
                    model: this.model.hitsSelect
                });
            }
        }
    },

    /**
     * handle specs visibility toggle change
     * @param  {object} e event object
     */
    onSpecsToggle: function(e) {

        e.preventDefault();

        //save toggled value to model
        this.model.specsVisible = (!this.model.specsVisible);
        productCatalogApp.showSpecs = this.model.specsVisible;

        //broadcast change result with boolean value of checkbox as parameter
       // HPEServices.publish(HPEConstants.catalog.SPECS_CHANGE, this.model.specsVisible);
        productCatalogApp.trigger('SPECS_CHANGE', {'specTrigger': this.model.specsVisible});

        //update/save the cookie
        Cookies.set(HPEConstants.catalog.SHOW_SPECS_COOKIE, this.model.specsVisible);
    }
});
